import { SnackbarProvider } from 'notistack';
import QSTheme from './theme/Theme.js';
import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import { Router } from 'react-router-dom';
import Main from './routes/Main';
import '../css/app.css';
import { MuiThemeProvider } from '@material-ui/core';
import { Provider } from 'react-redux';
import { persistor, store } from './redux/configureStore';
import { PersistGate } from 'redux-persist/integration/react';
import history from './history';
import Notifier from './snackbars/Notifier';

const App = () => (
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <MuiThemeProvider theme={QSTheme}>
        <SnackbarProvider maxSnack={1}>
          <Router history={history}>
            <div id="body">
              <CssBaseline />
              <Notifier />
              <Main />
            </div>
          </Router>
        </SnackbarProvider>
      </MuiThemeProvider>
    </PersistGate>
  </Provider>
);

export default App;
